import UiSlider from './UiSlider'
import GetForm from './GetForm'
import GetPhoneForm from './GetPhoneForm'
import PhoneModal from '../Modals/PhoneModal'

export default function Components(Vue) {
  Vue.component('UiSlider', UiSlider)
  Vue.component('PhoneModal', PhoneModal)
  Vue.component('GetForm', GetForm)
  Vue.component('GetPhoneForm', GetPhoneForm)
}



// WEBPACK FOOTER //
// ./src/js/components/app/Forms/index.js